module.exports = __webpack_public_path__ + "img/POP-00012-2.e98b70bf.png";